import { Component } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from 'src/app/loading/loading.service';
import { users } from 'src/app/models/Login';
import { User_Update, Usuario_List } from 'src/app/models/Usuario';
import { HistorialAccion } from 'src/app/models/QR';
import { QrService } from 'src/app/service/qr.service';
import { StorageService } from 'src/app/service/storage.service';

@Component({
  selector: 'app-usuario',
  templateUrl: './usuario.component.html',
  styleUrls: ['./usuario.component.css']
})
export class UsuarioComponent {
  loading$ = this.loadingService.loading$;

  qrCodeDownloadLink: SafeUrl = '';

  filtro: string = '';

  codigo: string = '';
  nombres: string = '';
  apellidos: string = '';
  correo: string = '';
  contrasena: string = '';
  estado: string = '';
  rol: string = '';
  id_user: number = 0;
  estado_bit: boolean = false;
  Usuario_List: Usuario_List[] = [];
  Historial_List: HistorialAccion[] = [];
  Historial_Filtrado: HistorialAccion[] = [];
  usuarioHistorialSeleccionado: Usuario_List | undefined;
  actualiza_User: User_Update | undefined;
  cantidad_registros: number = 0;
  activo_desactivo: string = '';
  user: users | undefined;
  bootstrap: any;

  constructor(private modulesService: QrService,
    private storage: StorageService,
    private route: Router,
    private toastr: ToastrService,
    private loadingService: LoadingService) {
  }

  ngOnInit(): void {
    this.loadingService.show();
    const usuarioStorage = this.storage.getUsuarioStorage();

    if (!usuarioStorage || Object.keys(usuarioStorage).length === 0) {
      this.route.navigate(['/login']);
      this.loadingService.hide();
    } else {
      this.Lista_Usuarios();
      this.Lista_Historial_Acciones();
      this.loadingService.hide();
    }


  }

  Lista_Historial_Acciones() {
    this.modulesService.Lista_Historial_Acciones().subscribe(
      data => {
        this.Historial_List = data ?? [];
      }
    )
  }

  verHistorialUsuario(usuario: Usuario_List) {
    this.usuarioHistorialSeleccionado = usuario;
    this.Historial_Filtrado = this.Historial_List.filter(h => h.id_usuario === usuario.id);
  }

  Lista_Usuarios() {
    this.cantidad_registros = 0;
    if (this.filtro == '') {
      this.modulesService.Lista_Usuarios('todos').subscribe(
        data => {
          console.log('SALIDA:' + JSON.stringify(data));
          this.Usuario_List = data;
          this.cantidad_registros = data.length;
        }
      )
    } else {
      this.modulesService.Lista_Usuarios(this.filtro).subscribe(
        data => {
          //   console.log('SALIDA:' + JSON.stringify(data));
          this.Usuario_List = data;
          this.cantidad_registros = data.length;
        }
      )
    }

  }



  onChangeURL(url: SafeUrl) {
    this.qrCodeDownloadLink = url;
    //  this.myAngularxQrCode= url;
  }
  /*
    cargaPoputDetalle(data: any) {
      this.id_user = 0;
      this.codigo = '';
      this.nombres = '';
      this.apellidos = '';
      this.correo = '';
      this.estado = '';
      this.rol = '';
      this.estado_bit = false;
      console.log(JSON.stringify(data.nombres));
      this.id_user = data.id;
      this.codigo = JSON.stringify(data.codigo);
      this.nombres = data.nombres;
      this.apellidos = data.apellidos;
      this.correo = data.email;
      this.estado = data.estado;
      this.rol = data.rol;
      if (data.estado == "activo") {
        this.estado_bit = true;
        this.activo_desactivo = "desactivar";
      }
      else {
        this.activo_desactivo = "activar";
      }
  
    }
    */


  desactivarCuenta(id: any, estado: any) {
    console.log('Desactivar:' + id + '----' + estado);

    this.actualiza_User = new User_Update;
    this.actualiza_User.id_user = id;
    if (estado == 1) {
      this.actualiza_User.estado = 0;
    } else {
      this.actualiza_User.estado = 1;
    }

   
    this.modulesService.Actualizar_Usuario(this.actualiza_User).subscribe(
      async (message2: any) => {
        //      console.log('RESULTADO UPDATE:' + JSON.stringify(message2));
        this.toastr.success(message2[0].mensaje, 'GOOD');
        this.Lista_Usuarios();
      }
    )

  }

  registrarUsuario() {

    console.log('Nombres:' + this.nombres + '--' +
      'Apellidos:' + this.apellidos + '--' +
      'correo:' + this.correo + '--' +
      'ROL:' + this.rol +
      'psw:' + this.contrasena
    );
  /*  if (!this.validarDominioCorreo(this.correo)) {
      this.toastr.error('ERROR', 'El correo electrónico debe tener el dominio @claro.com.pe');
      return;
    }*/
    
    if (this.validaciones_Registro()) {
      this.user = new users();
      this.user.nombre = this.nombres;
      this.user.apellidos = this.apellidos;
      this.user.email = this.correo;
      this.user.rol = this.rol;
      this.user.password = this.contrasena;

      this.modulesService.RegistrarUsuario(this.user).subscribe(
        async (message2: any) => {
          console.log('Respuesta de la API:' + JSON.stringify(message2));
          if (message2[0].nro_respuesta == 0) {
            this.toastr.info('Registro', message2[0].mensaje);

            const modalElement = document.getElementById('exampleModal');
            if (modalElement) {
              const modal = this.bootstrap.Modal.getInstance(modalElement);
              if (modal) {
                modal.hide();
              }

            }
          } else {
            this.toastr.error('ERROR', message2[0].mensaje);
          }

        }
      )

    }


  }


  validaciones_Registro() {
    if (this.nombres == "" || this.nombres == null || this.nombres == undefined) {
      this.toastr.warning('Debe ingresar el campo nombre');
      return false;
    }
    else if (this.apellidos == "" || this.apellidos == null || this.apellidos == undefined) {
      this.toastr.warning('Debe ingresar el campo apellido');
      return false;
    }
    else if (this.correo == "" || this.correo == null || this.correo == undefined) {
      this.toastr.warning('Debe ingresar el campo correo');
      return false;
    }
    else if (this.rol == "" || this.rol == null || this.rol == undefined) {
      this.toastr.warning('Debe ingresar el campo rol');
      return false;
    }
    else if (this.contrasena == "" || this.contrasena == null || this.contrasena == undefined) {
      this.toastr.warning('Debe ingresar el campo contraseña');
      return false;
    }
    else {
      return true;
    }
  }

  validarDominioCorreo(email: string): boolean {
    const dominioValido = 'claro.com.pe';
    const emailDomain = email.split('@')[1];
    return emailDomain === dominioValido;
  }

}
